<template>
  <div class="activity-edit-root">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        :to="{
          name: 'ProjectActivities',
          query: { project: currentProjectId },
        }"
        >活动管理
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{
        isEdit ? "编辑活动" : "创建活动"
      }}</el-breadcrumb-item>
    </el-breadcrumb>

    <TakoPanel
      :header="false"
      style="padding: 40px 20px 20px 20px; margin-top: 20px"
    >
      <el-form
        size="large"
        ref="activityFormRef"
        :model="activityFormData"
        :rules="formRules"
        label-width="140px"
        class="activity-form"
        style="width: 900px"
      >
        <el-form-item label="活动名称:" prop="activityname">
          <el-input
            v-model="activityFormData.activityname"
            placeholder="请输入活动名称"
          />
        </el-form-item>

        <el-form-item label="活动时间:" prop="timeRange">
          <el-date-picker
            v-model="activityFormData.timeRange"
            :default-time="['1970-1-1 10:00', '1970-1-1 18:00']"
            style="width: 100%"
            type="datetimerange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="YYYY-MM-DD HH:mm"
          />
        </el-form-item>

        <el-form-item label="活动类型:" prop="category">
          <el-input
            v-model="activityFormData.category"
            placeholder="请输入活动类型"
          />
          <!-- <el-autocomplete
            class="inline-input"
            v-model="formData.category"
            :fetch-suggestions="suggestCategory"
            style="width: 100%;"
            placeholder="请输入活动类型"></el-autocomplete> -->
        </el-form-item>

        <el-form-item label="活动说明:" prop="desc">
          <el-input
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="activityFormData.desc"
            placeholder="请输入活动说明"
            type="textarea"
          />
        </el-form-item>

        <el-form-item
          label="关联应用:"
          prop="versionids"
          class="uoloadSty"
          :class="{ disUoloadSty: noneBtnImg }"
        >
          <el-button
            v-if="showAddiOS"
            size="default"
            type="primary"
            @click="handleOpenAppDialog('iOS')"
            >+ 添加&nbsp;<i class="iconfont icon-apple"></i>
          </el-button>
          <el-button
            v-if="showAddAndroid"
            size="default"
            type="primary"
            @click="handleOpenAppDialog('Android')"
            >+ 添加&nbsp;<i class="iconfont icon-android"></i>
          </el-button>
          <el-button
            v-if="showAddWindows"
            size="default"
            type="primary"
            @click="handleOpenAppDialog('Windows')"
            >+ 添加&nbsp;<i class="iconfont icon-windows"></i>
          </el-button>
          <el-button
            v-if="showAddMacOS"
            size="default"
            type="primary"
            @click="handleOpenAppDialog('MacOS')"
            >+ 添加&nbsp;<i class="iconfont icon-app-store"></i>
          </el-button>
          <el-button
            v-if="showAddLinux"
            size="default"
            type="primary"
            @click="handleOpenAppDialog('Linux')"
            >+ 添加&nbsp;<i class="iconfont icon-linux"></i>
          </el-button>

          <el-table
            v-if="selectedVersions.length"
            :data="selectedVersions"
            style="
              border: solid 1px #eee;
              border-radius: 4px;
              width: 100%;
              margin-top: 12px;
            "
          >
            <el-table-column label="应用" prop="appname">
              <template #default="scope">
                <i
                  :class="[
                    'iconfont',
                    'icon-' + (iconEnum[scope.row.platform - 1] || 'warning'),
                  ]"
                ></i>
                <span> &nbsp;{{ scope.row.appname }} </span>
              </template>
            </el-table-column>
            <el-table-column label="版本" prop="versionname" width="120" />
            <el-table-column label="Build id" prop="buildnumber" width="90" />
            <el-table-column label="大小" prop="package.size" width="70">
              <template #default="scope">{{
                humanSize(scope.row.size)
              }}</template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createtime" width="150">
              <template #default="scope">{{
                formatDateTime(scope.row.createtime)
              }}</template>
            </el-table-column>
            <el-table-column label="" width="80">
              <template #default="scope">
                <el-button
                  size="small"
                  type="danger"
                  plain
                  @click="handleRemoveApp(scope.row)"
                  >移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="活动公开:" prop="ispublic">
          <el-radio v-model="activityFormData.ispublic" :label="true"
            >公开
          </el-radio>
          <el-radio v-model="activityFormData.ispublic" :label="false"
            >不公开
          </el-radio>
        </el-form-item>
        <el-form-item
          v-if="!activityFormData.ispublic"
          label="选择测试人员:"
          prop="members"
        >
          <el-select
            v-model="activityFormData.members"
            :multiple="true"
            :filterable="true"
            :default-first-option="true"
            placeholder="请选择测试人员"
            style="width: 100%"
          >
            <el-option
              v-for="user in testUsers"
              :key="user.username"
              :label="user.username"
              :value="user.username"
              style="max-width: 50vw"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="!activityFormData.ispublic"
          label="选择测试组:"
          prop="groupids"
        >
          <el-select
            v-model="activityFormData.groupids"
            :multiple="true"
            :filterable="true"
            :default-first-option="true"
            placeholder="请选择测试组"
            style="width: 100%"
          >
            <el-option
              v-for="group in testGroups"
              :key="group.groupid"
              :label="group.groupname"
              :value="group.groupid"
            />
          </el-select>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button v-if="isEdit" @click="handleGoBack">返回</el-button>

          <el-button
            v-if="activityFormData.status == activityStatus.draft"
            @click="handelSubmit(true)"
            >存为草稿</el-button
          >

          <el-button type="primary" @click="handelSubmit(false)">
            {{
              isEdit && activityFormData.status != activityStatus.draft
                ? "更新活动"
                : "发布活动"
            }}
          </el-button>
        </el-form-item>
      </el-form>
    </TakoPanel>

    <el-dialog
      center
      v-model="appDialogVisible"
      :title="appDialogTitle"
      width="520px"
    >
      <el-form
        size="large"
        :model="appFormData"
        label-width="74px"
        style="width: 100%"
        class="app-form"
      >
        <el-form-item label="应用名称:">
          <div class="app-select-wrapper">
            <el-select
              v-model="appFormData.appId"
              :filterable="true"
              :default-first-option="true"
              placeholder="请选择应用"
              style="width: 100%"
              @change="handleAppSelect"
            >
              <AppSelectOptions :apps="appOptions" />
            </el-select>
            <i
              v-if="appFormData.app"
              :class="[
                'iconfont',
                'icon-' + iconEnum[appFormData.app.platform - 1],
              ]"
              class="platform-icon"
            ></i>
          </div>
        </el-form-item>
        <el-form-item label="应用版本:">
          <el-select
            v-loading="loadingVersions"
            v-model="appFormData.versionId"
            :filterable="true"
            :default-first-option="true"
            placeholder="请选择版本"
            style="width: 100%"
          >
            <el-option
              v-for="v in versionOptions"
              :key="v.id"
              :label="`${v.package.version} (Build ${v.package.buildnumber})`"
              :value="v.id"
            >
              <span
                >{{ v.package.version }} (Build
                {{ v.package.buildnumber }})</span
              >
              <span
                v-if="v.createtime"
                style="float: right; color: #8492a6; font-size: 12px"
              >
                {{ formatDateTime(v.createtime) }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer>
        <div style="margin-top: -20px; text-align: right">
          <el-button @click="appDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleAddApp">确 定 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  watch,
  ref,
  reactive,
  getCurrentInstance,
} from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { useProjectStore } from "@/Store/ProjectStore";
import {
  apiGetActivityCategory,
  apiGetActivityList,
  apiGetAppVersions,
  apiModifyActivity,
  apiNewActivity,
} from "@/Api/AppApi";
import { humanSize, formatDateTime } from "@/Utils/UtilTools";
import settings from "@/settings";
import TakoPanel from "@/Components/TakoPanel.vue";
import AppSelectOptions from "@/Components/AppDetail/Detail/Info/AppSelectOptions.vue";

const route = useRoute();
const router = useRouter();

const projectStore = useProjectStore();
const { currentProjectId, testUsers, testGroups, projectApps } =
  storeToRefs(projectStore);

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const $moment = appContext.config.globalProperties.$moment;

const isEdit = computed(() => route.query.action === "edit");
const activityId = computed(() => route.query.id);
onMounted(() => {
  if (isEdit.value) {
    if (currentProjectId.value && activityId.value) {
      getActivity();
    }
  }
  getCategories();
});
watch([activityId, currentProjectId], () => {
  if (
    route.name === "ProjectActivities" &&
    (route.query.action === "edit" || route.query.action === "new")
  ) {
    if (currentProjectId.value && activityId.value) {
      getActivity();
    }
  }
});

const categories = ref([]);
async function getCategories() {
  const res = await apiGetActivityCategory(currentProjectId.value);
  if (res.code === 0) {
    categories.value = (res.data.data || []).filter((c) => {
      return c.length > 0;
    });
  } else {
    $message.error(res.message);
  }
}

const activityStatus = {
  0: "draft",
  1: "published",
  2: "closed",
  3: "pending",
  4: "opening",
  5: "over",
  draft: 0,
  published: 1,
  closed: 2,
  pending: 3,
  opening: 4,
  over: 5,
};

const formRules = {
  activityname: [
    { required: true, message: "请填写活动名称", trigger: "blur" },
  ],
  timeRange: [{ required: true, message: "请选择活动时间", trigger: "blur" }],
  versionids: [{ required: true, message: "请选择关联应用", trigger: "blur" }],
};

const isLoading = ref(false);
const activityFormData = reactive({
  activityid: "",
  activityname: "",
  projectid: "",
  timeRange: null,
  category: "",
  desc: "",
  status: activityStatus.draft,
  ispublic: false,
  versionids: [],
  members: [],
  groupids: [],
});
async function getActivity() {
  isLoading.value = true;
  const res = await apiGetActivityList(currentProjectId.value, {
    activityid: activityId.value,
  });
  isLoading.value = false;
  if (res.code === 0) {
    const data = (res.data.data || [{}])[0] || {};
    activityFormData.activityid = data.activityid;
    activityFormData.activityname = data.activityname;
    activityFormData.projectid = data.projectid;
    activityFormData.timeRange = [data.starttime, data.endtime];
    activityFormData.category = data.category;
    activityFormData.desc = data.desc;
    activityFormData.status = data.status;
    activityFormData.ispublic = data.ispublic;
    activityFormData.versionids = (data.versions || []).map((v) => {
      return v.versionname;
    });
    activityFormData.members = (data.members || []).map((m) => {
      return m.name;
    });
    activityFormData.groupids = (data.groups || []).map((g) => {
      return g.groupid;
    });

    data.versions.forEach((v) => {
      pushSelectedVersions(v);
    });
  } else {
    $message.error(res.message);
  }
}

const selectedVersions = ref([]);
const noneBtnImg = ref(false);
function pushSelectedVersions(version) {
  selectedVersions.value.push({
    id: version.id,
    appid: version.appid,
    appname: version.package.appname,
    platform: version.package.platform,
    versionname: version.package.version,
    buildnumber: version.package.buildnumber,
    size: version.package.size,
    createtime: version.createtime,
  });

  noneBtnImg.value = selectedVersions.value.length >= 1;
}
function handleRemoveApp(version) {
  selectedVersions.value = selectedVersions.value.filter(function (v) {
    return v.id != version.id;
  });
  noneBtnImg.value = selectedVersions.value.length >= 1;
}

const iconEnum = ["apple", "android", "windows", "app-store", "linux"];
const platformEnum = {
  iOS: 1,
  Android: 2,
  Windows: 3,
  MacOS: 4,
  Linux: 5,
  1: "iOS",
  2: "Android",
  3: "Windows",
  4: "MacOS",
  5: "Linux",
};
const showAddiOS = computed(
  () => !selectedVersions.value.some((v) => v.platform === platformEnum.iOS)
);
const showAddAndroid = computed(
  () => !selectedVersions.value.some((v) => v.platform === platformEnum.Android)
);
const showAddWindows = computed(
  () => !selectedVersions.value.some((v) => v.platform === platformEnum.Windows)
);
const showAddMacOS = computed(
  () => !selectedVersions.value.some((v) => v.platform === platformEnum.MacOS)
);
const showAddLinux = computed(
  () => !selectedVersions.value.some((v) => v.platform === platformEnum.Linux)
);

const appDialogVisible = ref(false);
const appPlatform = ref(0);
const appFormData = reactive({
  app: null,
  appId: "",
  versionId: "",
});
const versionOptions = ref([]);
function handleOpenAppDialog(platform) {
  appDialogVisible.value = true;
  appPlatform.value = platformEnum[platform];

  appFormData.app = null;
  appFormData.appId = "";
  appFormData.versionId = "";

  versionOptions.value = [];
}
const appDialogTitle = computed(
  () => `添加 ${platformEnum[appPlatform.value]} 应用`
);
const appOptions = computed(() =>
  projectApps.value.filter((app) => app.platform === appPlatform.value)
);

function handleAppSelect(appId) {
  for (const app of projectApps.value) {
    if (app.id === appId) {
      appFormData.app = app;
      break;
    }
  }
  getAppVersions(appId);
}
const loadingVersions = ref(false);
const appVersions = {}; // 各应用的版本列表(缓存)
async function getAppVersions(appId) {
  appFormData.versionId = "";
  versionOptions.value = [];
  const rv = appFormData.app.releaseversion || {};
  if (rv.id) {
    versionOptions.value.push(rv);
    appFormData.versionId = rv.id;
  }
  if (appVersions[appId]) {
    versionOptions.value = appVersions[appId];
    return;
  }

  loadingVersions.value = true;
  const res = await apiGetAppVersions(appId, {
    cursor: 0,
    count: settings.MaxPageCount,
  });
  loadingVersions.value = false;
  if (res.code === 0) {
    const versions = res.data.data || [];
    versionOptions.value = versions;
    appVersions[appId] = versions;
  } else {
    $message.error(res.message);
  }
}

function handleGoBack() {
  router.back();
}

const activityFormRef = ref(null);
function handelSubmit(isDraft) {
  activityFormData.versionids = selectedVersions.value.map((v) => {
    return v.id;
  });
  activityFormRef.value.validate(async (valid) => {
    if (!valid) {
      $message.error("表单数据有错误哦~");
      return;
    }

    const d = activityFormData;
    const postData = {
      activityname: d.activityname,
      projectid: currentProjectId.value,
      starttime: $moment(d.timeRange[0]).format(),
      endtime: $moment(d.timeRange[1]).format(),
      category: d.category,
      desc: d.desc,
      status: isDraft ? activityStatus.draft : activityStatus.published,
      ispublic: d.ispublic,
      versionids: d.versionids,
      members: d.ispublic ? [] : d.members,
      groupids: d.ispublic ? [] : d.groupids,
    };
    if (isEdit.value) {
      postData.id = d.activityid; // 兼容后端接口
      postData.activityid = d.activityid;
    }

    const res = await (isEdit.value
      ? apiModifyActivity(currentProjectId.value, postData)
      : apiNewActivity(currentProjectId.value, postData));

    if (res.code === 0) {
      if (isEdit.value) {
        activityFormData.status = postData.status;
        $message.success("修改成功");
        return;
      }

      router.push({
        name: "ProjectActivities",
        query: { project: currentProjectId.value },
      });
    } else {
      if (res.message === "duplicate activity name") {
        $message.error("当前活动名称已被使用，请更换！");
      } else {
        $message.error(res.message);
      }
    }
  });
}

function handleAddApp() {
  const version = versionOptions.value.find(function (v) {
    return v.id == appFormData.versionId;
  });
  if (version === undefined) {
    $message.warning("请选择应用名称和版本");
    return;
  }

  if (
    selectedVersions.value.some(function (v) {
      return v.id == version.id;
    })
  ) {
    $message.warning("应用已经在活动中了哦~");
    return false;
  }

  pushSelectedVersions(version);
  appDialogVisible.value = false;
}
</script>

<style lang="scss" scoped>
.activity-edit-root {
  padding: 20px;
}
.app-select-wrapper {
  user-select: none;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  position: relative;

  :deep() {
    .el-input__inner {
      padding-right: 50px;
    }
  }

  .platform-icon {
    font-size: 18px;
    position: absolute;
    right: 32px;
    top: 0px;
    padding: 0px 10px;
    pointer-events: none;
  }
}

.activity-form .el-form-item {
  max-width: 540px;
}

.activity-form .el-form-item.uoloadSty {
  max-width: 850px;
}
.activity-form .el-form-item.disUoloadSty >>> .el-form-item__error {
  display: none;
}
</style>
